// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var OpinionScale$ReactHooksTemplate = require("./OpinionScale.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var OpinionScaleLabel$ReactHooksTemplate = require("./OpinionScaleLabel.res.js");

function OpinionScaleDefaultForm$OpinionScaleItem(props) {
  var onSelection = props.onSelection;
  var step = props.step;
  return JsxRuntime.jsx("button", {
              children: JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("span", {
                          children: String(step)
                        })
                  }),
              className: props.className,
              style: props.style,
              onClick: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(onSelection, step);
                })
            });
}

var OpinionScaleItem = {
  make: OpinionScaleDefaultForm$OpinionScaleItem
};

function colorBasedOnLikelyness(index) {
  switch (index) {
    case 0 :
    case 1 :
    case 2 :
    case 3 :
    case 4 :
        return "#f5d0d0";
    case 5 :
    case 6 :
        return "#d9daf8";
    case 7 :
    case 8 :
    case 9 :
    case 10 :
        return "#c7f8d8";
    default:
      return "#ffffff";
  }
}

function OpinionScaleDefaultForm(props) {
  var substitutionVariables = props.substitutionVariables;
  var onChange = props.onChange;
  var mandatory = props.mandatory;
  var language = props.language;
  var opinionScale = props.opinionScale;
  var selectedCss = function (x) {
    if (OpinionScale$ReactHooksTemplate.isAnswer(opinionScale, x)) {
      return "text-vistablue border-2 border-bleudefrance";
    } else {
      return "";
    }
  };
  var items = function (a, b) {
    return $$Array.of_list(Belt_List.mapWithIndex(Belt_List.makeBy((b - a | 0) + 1 | 0, (function (x) {
                          return x;
                        })), (function (i, x) {
                      return JsxRuntime.jsx(OpinionScaleDefaultForm$OpinionScaleItem, {
                                  step: x + a | 0,
                                  className: selectedCss(x) + " small:w-6 small:h-6 w-12 h-12 small:rounded rounded-xl focus:outline-none\n                  text-darkcharcoal small:text-sm text-lg font-medium",
                                  onSelection: (function (scale) {
                                      Curry._1(onChange, OpinionScale$ReactHooksTemplate.setAnswer(opinionScale, scale));
                                    }),
                                  style: {
                                    backgroundColor: colorBasedOnLikelyness(i)
                                  }
                                }, String(i + a | 0));
                    })));
  };
  var rawText = OpinionScale$ReactHooksTemplate.getTextTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language));
  var rawDescription = OpinionScale$ReactHooksTemplate.getDescriptionTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawText, substitutionVariables) + (
    mandatory ? " *" : ""
  );
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-lg font-medium text-darkcharcoal py-6 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: titleHtml
                              }
                            }),
                        JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-base font-normal text-darkcharcoal pb-8 whitespace-pre-line",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            })
                      ]
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: items(0, 10),
                                    className: "flex small:gap-1 gap-2"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("p", {
                                            children: OpinionScaleLabel$ReactHooksTemplate.left(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                          }),
                                      JsxRuntime.jsx("p", {
                                            children: OpinionScaleLabel$ReactHooksTemplate.right(OpinionScale$ReactHooksTemplate.getLabelTranslation(opinionScale, SurveyLanguage$ReactHooksTemplate.name(language)))
                                          })
                                    ],
                                    className: " flex justify-between w-full pt-6 pb-10 text-spanishgray text-sm "
                                  }),
                              mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {
                                      language: language
                                    }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                            ],
                            className: "flex flex-col justify-between items-start"
                          }),
                      className: "flex w-full"
                    })
              ],
              className: "w-full px-16 small:px-6 " + props.borderCss
            });
}

var make = OpinionScaleDefaultForm;

exports.OpinionScaleItem = OpinionScaleItem;
exports.colorBasedOnLikelyness = colorBasedOnLikelyness;
exports.make = make;
/* react/jsx-runtime Not a pure module */
